import React, { Component } from 'react'
import { union, intersection } from 'lodash'
import { CheckboxGroup } from '../../components/inputs'
import {
  taskTypes,
  taskArrSupport,
  taskArrUnderwriting,
  taskArrFraud,
  taskArrTitle,
} from './taskTypes'

import { Task } from './types'

const taskTypeOptions = taskTypes

export type Callback<T = void> = (...args: any) => T

export const createRuleSet = (taskArray: Task[], currentUserBadges) => {
  let currentTaskArray: Task[] = []
  taskArray.map((task) => {
    const matchBadge = currentUserBadges.includes(task)

    if (matchBadge) {
      currentTaskArray.push(task)
    }
  })
  return currentTaskArray // what ops user is allowed to do
}

export const createNewState = (
  currentTaskArray: Task[],
  existingFormValues
) => {
  let returnedArray =
    existingFormValues && existingFormValues.length > 0
      ? existingFormValues
      : []

  const matched = intersection(returnedArray, currentTaskArray)

  if (matched.length > 0) {
    return returnedArray.filter((value) => {
      return !matched.includes(value)
    })
  } else {
    return union(returnedArray, currentTaskArray)
  }
}

export interface Props {
  blur: Callback
  change: Callback
  currentUserBadges: string[]
  existingFormValues: object[]
}

export class TaskFilterCheckboxes extends Component<Props> {
  static displayName = 'TaskFilterCheckboxes'

  handleSelectCategory = (
    change,
    name,
    currentUserBadges,
    existingFormValues,
    taskArr,
    blur
  ) => {
    const currentTaskArray = createRuleSet(taskArr, currentUserBadges)
    const selectAllArr = createNewState(currentTaskArray, existingFormValues)
    blur(name, selectAllArr)
    change(name, selectAllArr)
  }

  render() {
    const { currentUserBadges, blur, change, existingFormValues } = this.props

    return (
      <div className="task-filter__row">
        <h2 className="filter__header">Tasks</h2>
        <hr className="form__hr  filter__button-hr filter_hr" />
        <div className="task-filter__row__checkbox-group">
          <div className="task-filter--select-all">
            <input
              type="checkbox"
              name="support"
              id="checkbox-support"
              data-testid="checkbox-support"
              className="form__toggle"
              onChange={() =>
                this.handleSelectCategory(
                  change,
                  'taskType',
                  currentUserBadges,
                  existingFormValues,
                  taskArrSupport,
                  blur
                )
              }
            />
            <label htmlFor="checkbox-support">Support</label>

            <input
              type="checkbox"
              name="underwriting"
              id="checkbox-underwriting"
              className="form__toggle"
              onChange={() =>
                this.handleSelectCategory(
                  change,
                  'taskType',
                  currentUserBadges,
                  existingFormValues,
                  taskArrUnderwriting,
                  blur
                )
              }
            />
            <label htmlFor="checkbox-underwriting">Underwriting</label>

            <input
              type="checkbox"
              name="fraud"
              id="checkbox-fraud"
              className="form__toggle"
              onChange={() =>
                this.handleSelectCategory(
                  change,
                  'taskType',
                  currentUserBadges,
                  existingFormValues,
                  taskArrFraud,
                  blur
                )
              }
            />
            <label htmlFor="checkbox-fraud">Lead / Fraud</label>

            <input
              type="checkbox"
              name="title"
              id="checkbox-title"
              className="form__toggle"
              onChange={() =>
                this.handleSelectCategory(
                  change,
                  'taskType',
                  currentUserBadges,
                  existingFormValues,
                  taskArrTitle,
                  blur
                )
              }
            />
            <label htmlFor="checkbox-title">Title</label>
          </div>
          <CheckboxGroup
            name="taskType"
            gridColumn
            options={taskTypeOptions}
            currentUserBadges={currentUserBadges}
          />
        </div>
      </div>
    )
  }
}
